import { createContext, useContext } from 'react';

import type Cropper from 'cropperjs';

import type { TranslationKey } from '@change-corgi/core/i18n';

import type { Action } from './actions';
import type { MediaCropArea } from './types';

type Dispatch = (action: Action) => void;

export type ImageUploadState = {
	image: string | undefined;
	imageChanged: boolean;
	imageCrop: MediaCropArea | undefined;
	errorMessage: TranslationKey | null;
	fileType: string | null;
	cropper: Cropper | undefined;
};

export type ImageUploadContextType = { state: ImageUploadState; dispatch: Dispatch };

export const ImageUploadContext = createContext<ImageUploadContextType | undefined>(undefined);

export function useImageUploadContext(): ImageUploadContextType {
	const context = useContext(ImageUploadContext);
	if (context === undefined) {
		throw new Error('useImageUploadContext must be used within a ImageUploadProvider');
	}
	return context;
}
